import {
  EMPTY_PRELOADED_FORMS,
  getPreloadedForm as pickPreloadedForm,
  type PreloadedForm,
  type PreloadedForms,
} from '@wix/communities-blog-client-common';
import { type AppState } from '../../common/types';

const getPreloadedForms = (state: AppState): PreloadedForms =>
  state.preloadedForms ?? EMPTY_PRELOADED_FORMS;

// One cached join per form id: the join allocates, and the renderer keys an effect on it.
const cache = new WeakMap<PreloadedForms, Map<string, PreloadedForm | undefined>>();

/** One preloaded form joined with the shared locale resources, referentially stable per state. */
export const getPreloadedForm = (state: AppState, formId: string): PreloadedForm | undefined => {
  const preloaded = getPreloadedForms(state);
  let byId = cache.get(preloaded);
  if (!byId) {
    byId = new Map();
    cache.set(preloaded, byId);
  }
  if (!byId.has(formId)) {
    byId.set(formId, pickPreloadedForm(preloaded, formId));
  }
  return byId.get(formId);
};
